/**
 * Values the GTM tags read out of localStorage rather than the data layer.
 *
 * redux-persist writes each whitelisted slice under keyPrefix 'bs' plus the
 * reducer name (Components/Persistence/PersistStore), so state.auth is 'bsauth'
 * and state.ageGating is 'bsageGating'.
 */

const KEY_PREFIX = 'bs';

// null for anything unreadable — absent, malformed, or localStorage itself
// throwing, as it does in Safari private mode.
const readSlice = (slice) => {
  try {
    return JSON.parse(localStorage.getItem(`${KEY_PREFIX}${slice}`));
  } catch (e) {
    return null;
  }
};

// GTM's {{User Id}}: the _id from 'bsauth', '' when the record has none, and
// undefined when there is no record.
export const persistedUserId = () => {
  const auth = readSlice('auth');
  if (!auth) return undefined;
  return auth._id ? auth._id : '';
};

// The `ag` local in the split_test tag. The tag reads .success without a null
// check and catches the throw, so anything unreadable is false.
export const ageGatingPassed = () => {
  const ageGating = readSlice('ageGating');
  return !!(ageGating && ageGating.success);
};
